import Vue from 'vue'
import ConfirmModal from '@v2/components/common/ConfirmModal'
import RealNameCouponModal from '@v2/components/common/RealNameCouponModal'
import IdentityConfirmModal from '@v2/components/common/IdentityConfirmModal'

let modal = {
  getModalInstance: (ModalComponent, props) => {
    const instance = new Vue({
      data: props,
      render: h => h(ModalComponent, { props: props })
    })
    const component = instance.$mount()
    document.getElementById(Vue.prototype.$style.cssClassName).appendChild(component.$el)
    const modal = instance.$children[0]
    return modal
  },
  showIdentityModal: (confirmCallback, closeCallback, syMoney, syOrder) => {
    let props = {
      confirmCallback: confirmCallback,
      closeCallback: closeCallback,
      syMoney: syMoney,
      syOrder: syOrder
    }
    let identityModal = modal.getModalInstance(IdentityConfirmModal, props)
    identityModal.show()
  },
  showConfirmModal: (content, title = '', confirmText = '', confirmCallback, closeCallback) => {
    let props = {
      showModal: true,
      content: '<p>' + content + '</p>',
      title: title,
      confirmText: confirmText,
      confirmCallback: confirmCallback,
      closeCallback: closeCallback
    }
    let confirmModal = modal.getModalInstance(ConfirmModal, props)
    confirmModal.show()
  },
  showRealNameCouponModal: (content, title = '', closeCallback) => {
    let props = {
      showMsgModal: true,
      msgContent: '<p>' + content + '</p>',
      msgTitle: title,
      closeBack: closeCallback
    }
    modal.getModalInstance(RealNameCouponModal, props)
  },
  closeIdentityModal: () => {
    let identityClass = document.getElementById('identityClass')
    identityClass.parentNode.removeChild(identityClass)
  }
}

export default modal



// WEBPACK FOOTER //
// ./src/v2/static/js/modal.js